import React from 'react'
import HotsheetsSvg from 'images/modules/Manage/i-menu-hotsheets.svg?raw'

export { default as HotsheetsUrl } from 'images/modules/Manage/i-menu-hotsheets.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: HotsheetsSvg}} />
)
